import { fetchJson } from "src/utils/apiUtils";
import {
  IRemyndCategoryPartnerMapFullData,
  IRemyndCategoryPartnerMapSaveReq
} from "./types";

const endpoint = `master/remyndCategoryPartnerMap`;

export const listFullData = async (partnerId: PartnerId) => {
  return fetchJson<IResponse<IRemyndCategoryPartnerMapFullData>>(
    `${endpoint}/listFullData?partnerId=${partnerId}`,
    { method: "GET" }
  );
};

export const save = async (req: IRemyndCategoryPartnerMapSaveReq) => {
  return fetchJson<IResponse<RemyndCategoryPartnerMapId>>(`${endpoint}/save`, {
    method: "POST",
    body: JSON.stringify({ ...req })
  });
};

export const update = async (
  id: RemyndCategoryPartnerMapId,
  req: IRemyndCategoryPartnerMapSaveReq
) => {
  return fetchJson<IResponse<RemyndCategoryPartnerMapId>>(
    `${endpoint}/update/${id}`,
    {
      method: "POST",
      body: JSON.stringify({ ...req })
    }
  );
};

export const deleteMultiple = async (req: ICommonIdsReq) => {
  return fetchJson<IResponse<null>>(`${endpoint}/delete`, {
    method: "DELETE",
    body: JSON.stringify({ ...req })
  });
};
